import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAccountingCalculator = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "accounting-calculator" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 3.75,
			y: .75,
			width: 16.5,
			height: 22.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 6.75,
			y: 3.75,
			width: 10.5,
			height: 4.5,
			rx: .75,
			ry: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.875,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,7.875,12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.156,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,12.156,12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.125,12a.375.375,0,1,1-.375.375A.375.375,0,0,1,16.125,12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.875,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.156,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.125,15.75a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.875,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.156,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.125,19.5a.375.375,0,1,1-.375.375.375.375,0,0,1,.375-.375"
		})
	]
});
export default SvgAccountingCalculator;
